import { useReadLocalStorage } from 'usehooks-ts';
// Overrides only needed to get `T` as return value, instead of `T | null` when initial`Value is specified
export function useReadLocalStorageBase(key, initialValue, options) {
    return useReadLocalStorage(key, options) ?? initialValue ?? null;
}
